import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9cc4b12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"absolute","width":"150px","height":"50px","padding":"5px","right":"0px","z-index":"999"} }
const _hoisted_2 = {
  class: "common-layout",
  style: {"padding":"3px 3px","border-radius":"5px"}
}
const _hoisted_3 = { class: "logo-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "titleBlankDiv",
  style: {"width":"100%","height":"10px","background-color":"#0DB4C9"}
}, null, -1))
const _hoisted_5 = {
  key: 0,
  style: {"width":"100%","height":"50px","background-color":"#0DB4C9"}
}
const _hoisted_6 = { class: "custom-tabs-label homePageTab" }
const _hoisted_7 = ["src"]

import { reactive, onMounted, ref } from 'vue';
import $http from '../http/index';
import { ElTabs,ElTabPane,TabPaneName } from 'element-plus';
import { Edit,SwitchButton } from "@element-plus/icons-vue";
import ModifyPassWord from "@/views/component/ModifyPassWord.vue";

interface TabInfo {
    ID:string
    Name: string,
    RouterName: string,
    RouterPath:string,
    MenuIcon:string
}

interface MenuInfo{
    ID:string,
    MenuIcon:string,
    MenuName:string,
    MenuPath:string,
    ChildMenu:Array<MenuInfo>
}

interface BaseUser{
    ID:string,
    Account:string,
    Phone:string,
    RealName:string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const modifyPwdRef=ref();

class InitData {
    // router = useRouter();  
    companyLogoUrl = require('../assets/images/glory.png')  
    mainContainerStyle = "height: 200px;";
    mainMenuStyle ="height: 100px;"
    tableDataSource = 'codeSearch'
    tabPaneDivStyle='height: 200px;'

    showMenuInfo:Array<MenuInfo>=[]
    allMenuInfo:Array<MenuInfo>=[]
    tabHistories:Array<string>=[] //tab操作记录

    tabs:Array<TabInfo>=[]
    tabValue = ""
    CirclePlus="CirclePlus"
    currentUser:BaseUser={
        ID:'',
        Account:'',
        Phone:'',
        RealName:'',
    }
}

const data = reactive(new InitData());


onMounted(() => {
    adapterSize();
    window.onresize = () => {
        adapterSize();
        window.setTimeout(function(){
            adapterSize();
        },200);
    }
    getMenuButtomPerssion();
    getMenu();
    getUserInfo();
})

const adapterSize = ()=>{
    const padding = 7
    data.mainContainerStyle = `height: ${window.innerHeight-padding}px`
    let h = window.innerHeight-padding;
    data.mainMenuStyle = `height: ${h}px;background-color: #EEEEEE;border-top-left-radius: 5px;border-bottom-left-radius: 5px;`
    data.tabPaneDivStyle=`height: ${window.innerHeight-85}px;`;
    setTabTitleStyle();

};

/**
 * 设置 tab 组件头部样式
 */
const setTabTitleStyle=()=>{
    let tabTitles = document.getElementsByClassName('el-tabs__nav-scroll');
    let titleBlankDiv = document.getElementById("titleBlankDiv");
    let maxWith = 1000;
    if(titleBlankDiv){
        maxWith = titleBlankDiv.clientWidth;
    }
    for(let i=0;tabTitles && i<tabTitles.length;i++){
        let tabTitle = tabTitles[i];
        if(!tabTitle) continue;
        if(tabTitle.innerHTML.includes("homePageTab")){
            (tabTitle as HTMLDivElement).style.width=`${maxWith-150}px`;
        }
    }
}

/**
 * 获取菜单按钮权限数据
 */
const getMenuButtomPerssion = ()=>{
    $http({
        url: `/BaseRoleInfo/GetUserButtonCodes`,
        method: "Get",
        data: {}
    }).then(res => {
        window.localStorage.setItem("PermissionCodes",JSON.stringify(res.data))
    });
    GetAllMenuDatas();
}

/**
 * 获取菜单
 */
const getMenu = ()=>{
    $http({
        url: `/BaseRoleInfo/GetNavigateMenu`,
        method: "Get",
        data: {}
    }).then(res => {
        data.showMenuInfo=res.data
    });
    GetAllMenuDatas();
}

const GetAllMenuDatas = ()=>{
    $http({
        url: `/BaseMenuInfo/GetAllDatas`,
        method: "Get",
        data: {}
    }).then(res => {
        data.allMenuInfo=res.data
    });
}

/**
 * 移除tab页，并默认打开上一个tab页
 * */
const tabRemoveEvent=(tabName:TabPaneName)=>{
    data.tabs = data.tabs.filter(c=>c.ID != tabName.toString());
    const tabHistories:Array<string>=[];
    for(let i=0;i<data.tabHistories.length;i++){
        if(data.tabHistories[i]==tabName.toString()){
            continue;
        }
        tabHistories.push(data.tabHistories[i]);
    }
    data.tabHistories = tabHistories;

    const removeIndex = data.tabHistories.findIndex(c=>c==tabName.toString());
    if(removeIndex>-1){
        data.tabHistories = data.tabHistories.splice(removeIndex,1);
    }
    if(data.tabHistories.length>0){
        data.tabValue=data.tabHistories[data.tabHistories.length-1];
    }
}

const itemMemuClickEvent=(iteMenu:any)=>{
    const menuID:string|null = iteMenu.index;
    const index = data.allMenuInfo.findIndex(c=>c.ID==menuID);
    if(index>-1){
        const menu = data.allMenuInfo[index];
        const menuIndex =data.tabs.findIndex(c=>c.ID==menuID);
        if(menuIndex>-1){
            data.tabValue=data.tabs[menuIndex].ID;
            return;
        }
        if(!menu.MenuPath)return;
        data.tabs.push({ID:menu.ID,Name:menu.MenuName,RouterName:"",RouterPath:menu.MenuPath,MenuIcon:menu.MenuIcon})
        data.tabValue=menu.ID;
        data.tabHistories.push(menu.ID);//加入tab历史操作记录
    }
    setTabTitleStyle();
}

/**
 * 登出
 */
const logout=()=>{
        localStorage.setItem('AuthorizationToken','');
        localStorage.setItem('AuthorizationExpires','0');
        const rootAddr =  "http://"+window.location.host+"/#/login";
        window.location.href = rootAddr;
}

const getUserInfo=()=>{
    $http({
        url: `/BaseUser/GetCurrentUser`,
        method: "Get",
        data: {}
    }).then(res => {
        data.currentUser=res.data
        window.localStorage.setItem('CurrentUser',JSON.stringify(res.data))
    });
}

const ModifyPassWordOpen=()=>{
    modifyPwdRef.value.openDialog();
};


return (_ctx: any,_cache: any) => {
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, { style: {"margin-top":"3px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 10,
            push: 5,
            style: {"padding-top":"3px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown, { id: "logoutDropdown" }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        icon: _unref(Edit),
                        onClick: ModifyPassWordOpen
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("修改密码")
                        ]),
                        _: 1
                      }, 8, ["icon"]),
                      _createVNode(_component_el_dropdown_item, {
                        icon: _unref(SwitchButton),
                        onClick: logout
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("安全退出")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { style: {"color":"#FFF"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserFilled)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(data.currentUser.RealName) + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_container, {
        style: _normalizeStyle(data.mainContainerStyle)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, {
            width: "200px",
            style: _normalizeStyle(data.mainMenuStyle)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_scrollbar, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_image, {
                      class: "logo",
                      src: data.companyLogoUrl,
                      fit: "contain"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode(_component_el_menu, {
                    "default-openeds": [],
                    "unique-opened": "true",
                    "background-color": "#EEE",
                    "text-color": "#000",
                    style: {"width":"100%","border":"none"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.showMenuInfo, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.ID
                        }, [
                          (item.ChildMenu && item.ChildMenu.length>0)
                            ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                key: item.ID,
                                index: item.ID
                              }, {
                                title: _withCtx(() => [
                                  (item.MenuIcon && item.MenuIcon.length>0)
                                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.MenuIcon)))
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(item.MenuName), 1)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ChildMenu, (secondLevelItem) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: secondLevelItem.ID
                                    }, [
                                      (secondLevelItem.ChildMenu && secondLevelItem.ChildMenu.length>0)
                                        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                            key: secondLevelItem.ID,
                                            index: secondLevelItem.ID,
                                            class: "el-sub-menu"
                                          }, {
                                            title: _withCtx(() => [
                                              (secondLevelItem.MenuIcon && secondLevelItem.MenuIcon.length>0)
                                                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(), _createBlock(_resolveDynamicComponent(secondLevelItem.MenuIcon)))
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true),
                                              _createTextVNode(" " + _toDisplayString(secondLevelItem.MenuName), 1)
                                            ]),
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondLevelItem.ChildMenu, (threeLevelItem) => {
                                                return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                  key: threeLevelItem.ID,
                                                  index: secondLevelItem.ID,
                                                  onClick: itemMemuClickEvent
                                                }, {
                                                  default: _withCtx(() => [
                                                    (threeLevelItem.MenuIcon && threeLevelItem.MenuIcon.length>0)
                                                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(), _createBlock(_resolveDynamicComponent(threeLevelItem.MenuIcon)))
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(" " + _toDisplayString(threeLevelItem.MenuName), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["index"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["index"]))
                                        : (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 1,
                                            index: secondLevelItem.ID,
                                            onClick: itemMemuClickEvent
                                          }, {
                                            default: _withCtx(() => [
                                              (secondLevelItem.MenuIcon && secondLevelItem.MenuIcon.length>0)
                                                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(), _createBlock(_resolveDynamicComponent(secondLevelItem.MenuIcon)))
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true),
                                              _createTextVNode(" " + _toDisplayString(secondLevelItem.MenuName), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["index"]))
                                    ], 64))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["index"]))
                            : (_openBlock(), _createBlock(_component_el_menu_item, {
                                key: 1,
                                index: item.ID,
                                onClick: itemMemuClickEvent
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.MenuName), 1)
                                ]),
                                _: 2
                              }, 1032, ["index"]))
                        ], 64))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_el_main, { style: {"padding":"0px 0px 0px 0px","margin":"0px 0px 0px 0px","background-color":"#FFF","border-top-right-radius":"5px","border-bottom-right-radius":"5px"} }, {
            default: _withCtx(() => [
              _hoisted_4,
              (data.tabs.length<1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_unref(ElTabs), {
                modelValue: data.tabValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.tabValue) = $event)),
                type: "card",
                closable: "",
                onTabRemove: tabRemoveEvent,
                class: "mainPagetabs"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tabs, (item) => {
                    return (_openBlock(), _createBlock(_unref(ElTabPane), {
                      key: item.Name,
                      label: item.Name,
                      name: item.ID
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, [
                          (item.MenuIcon && item.MenuIcon.length>0)
                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.MenuIcon)))
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(item.Name), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          style: _normalizeStyle(data.tabPaneDivStyle)
                        }, [
                          _createElementVNode("iframe", {
                            src: item.RouterPath,
                            style: {"width":"100%","padding":"0px","margin":"0px","border":"0px","height":"100%"}
                          }, null, 8, _hoisted_7)
                        ], 4)
                      ]),
                      _: 2
                    }, 1032, ["label", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]), [
                [_vShow, data.tabs.length>0]
              ])
            ]),
            _: 1
          }),
          _createVNode(ModifyPassWord, {
            ref_key: "modifyPwdRef",
            ref: modifyPwdRef,
            onLogout: logout
          }, null, 512)
        ]),
        _: 1
      }, 8, ["style"])
    ])
  ], 64))
}
}

})